import { createSlice } from '@reduxjs/toolkit';
import request from '../../service';
import Exported from '../../service/endpoints';
import config from '../../service/env';

const initialState = {
  accessToken: null,
  sessionActive: false,
  userData: {},
  userPillar: null,
  userRole: null,
  permissions: [],
};
export const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    saveAccessToken: (state, action) => {
      state.accessToken = action.payload;
    },
    saveSessionActive: (state, action) => {
      state.sessionActive = action.payload;
    },
    saveUserData: (state, action) => {
      state.userData = action.payload;
    },
    saveUserPillar: (state, action) => {
      state.userPillar = action.payload;
    },
    saveUserRole: (state, action) => {
      state.userRole = action.payload;
    },
    savePermissions: (state, action) => {
      state.permissions = action.payload;
    },
  },
});

export const login = (data) => {
  return request({
    url: Exported.Endpoints.login,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const forgotPassword = (data) => {
  return request({
    url: Exported.Endpoints.forgotPassword,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const deactivateSendOTP = (data) => {
  return request({
    url: Exported.Endpoints.deactivateSendOTP,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const deactivateUser = (data) => {
  return request({
    url: Exported.Endpoints.deactivateUser,
    method: Exported.APIMethods.PATCH,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const reSendOtp = (data) => {
  return request({
    url: Exported.Endpoints.reSendOtp,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const verifyOTP = (data) => {
  return request({
    url: Exported.Endpoints.verifyOTP,
    method: Exported.APIMethods.POST,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const resetPassword = (data) => {
  return request({
    url: Exported.Endpoints.resetPassword,
    method: Exported.APIMethods.PUT,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const changePassword = (data) => {
  // Change on Profile Screen
  return request({
    url: Exported.Endpoints.changePassword,
    method: Exported.APIMethods.PUT,
    data,
    baseUrl: config.identityServiceApi,
  });
};

export const getUserPermissions = () => {
  return request({
    url: Exported.Endpoints.getUserPermissions,
    method: Exported.APIMethods.GET,
    baseUrl: config.identityServiceApi,
  });
};

export const {
  saveAccessToken,
  saveSessionActive,
  saveUserData,
  saveUserRole,
  saveUserPillar,
  savePermissions,
} = authSlice.actions;
export const access = (state) => state.auth.accessToken;
export const activeSession = (state) => state.auth.sessionActive;
export const selectUserRole = (state) => state.auth.userRole;
